import { Navigate, type RouteObject } from "react-router-dom";
import { KioskExit } from "./Exit";
import { KioskSetup } from "./Setup";

/**
 * Staff-side kiosk screens. The kiosk itself (`/kiosk` with a stored credential) is booted by `main.tsx` before the router
 * exists (see `boot.tsx`): it is not a route, so it can never sit inside the shell or beside a staff session.
 */
export const routes: RouteObject[] = [
  { path: "kiosk", element: <Navigate to="/kiosk/setup" replace /> },
  { path: "kiosk/setup", element: <KioskSetup /> },
  { path: "kiosk/exit", element: <KioskExit /> },
];
